import React, { useState } from "react";
import { Button } from "antd";
import {
  FilterOutlined,
  PlusOutlined,
  AppstoreOutlined,
  GiftOutlined,
} from "@ant-design/icons";
import InventoryFilters from "./InventoryFilters";

interface InventoryHeaderProps {
  onAddProductClick: () => void;
  onApplyFilters: (filters: Record<string, any>) => void;
  onClearFilters: () => void;
  onManageCategory: () => void;
  onPostPromotion: () => void;
  canAddInventory: boolean; // New prop for permission check
  canModifyInventory: boolean; // New prop for permission check
  canPostPromotion: boolean; // New prop for permission check
  canSeeAllLocations: boolean; // New prop for location permission
}

const InventoryHeader: React.FC<InventoryHeaderProps> = ({
  onAddProductClick,
  onApplyFilters,
  onClearFilters,
  onManageCategory,
  onPostPromotion,
  canAddInventory,
  canModifyInventory,
  canPostPromotion,
  canSeeAllLocations,
}) => {
  const [showFilters, setShowFilters] = useState(false);
  const [hoveredButton, setHoveredButton] = useState<string | null>(null);

  return (
    <div className="mb-6">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-xl font-bold">Inventory Management</h1>
        <div className="flex space-x-2">
          <div
            onMouseEnter={() => setHoveredButton("filters")}
            onMouseLeave={() => setHoveredButton(null)}
            className="button-container"
          >
            <Button
              icon={<FilterOutlined />}
              onClick={() => setShowFilters(!showFilters)}
              className={`icon-button ${
                hoveredButton === "filters" ? "expanded" : ""
              }`}
            >
              {hoveredButton === "filters" && "Filters"}
            </Button>
          </div>

          {/* Only show Manage Category button if user can modify inventory */}
          {canModifyInventory && (
            <div
              onMouseEnter={() => setHoveredButton("manageCategory")}
              onMouseLeave={() => setHoveredButton(null)}
              className="button-container"
            >
              <Button
                icon={<AppstoreOutlined />}
                onClick={onManageCategory}
                className={`icon-button ${
                  hoveredButton === "manageCategory" ? "expanded" : ""
                }`}
              >
                {hoveredButton === "manageCategory" && "Manage Category"}
              </Button>
            </div>
          )}

          {/* Only show Add Product button if user can add inventory */}
          {canAddInventory && (
            <div
              onMouseEnter={() => setHoveredButton("addProduct")}
              onMouseLeave={() => setHoveredButton(null)}
              className="button-container"
            >
              <Button
                icon={<PlusOutlined />}
                onClick={onAddProductClick}
                className={`icon-button ${
                  hoveredButton === "addProduct" ? "expanded" : ""
                }`}
              >
                {hoveredButton === "addProduct" && "Add Product"}
              </Button>
            </div>
          )}
          {canPostPromotion && (
            <div
              onMouseEnter={() => setHoveredButton("postPromotion")}
              onMouseLeave={() => setHoveredButton(null)}
              className="button-container"
            >
              <Button
                icon={<GiftOutlined />}
                onClick={onPostPromotion}
                className={`icon-button ${
                  hoveredButton === "postPromotion" ? "expanded" : ""
                }`}
              >
                {hoveredButton === "postPromotion" && "Post Promotion"}
              </Button>
            </div>
          )}
        </div>
      </div>

      {showFilters && (
        <InventoryFilters
          onApplyFilters={onApplyFilters}
          onClearFilters={onClearFilters}
          canSeeAllLocations={canSeeAllLocations}
        />
      )}
    </div>
  );
};

export default InventoryHeader;
